import React from 'react';

const CountdownGauge = ({ duration, timeLeft, threshold, radius = 100, stroke = 30 }) => {
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = normalizedRadius * 2 * Math.PI;
    const elapsed = duration - timeLeft;
    const progress = elapsed / duration;
    const strokeDashoffset = circumference - progress * circumference;

    return (
        <svg height={radius * 2} width={radius * 2}>
            {/* Background circle */}
            <circle
                stroke={timeLeft <= threshold ? 'red' : 'green'}
                fill="transparent"
                strokeWidth={stroke}
                r={normalizedRadius}
                cx={radius}
                cy={radius}
            />
            {/* Progress circle */}
            <circle
                stroke="#ccc"
                fill="transparent"
                strokeWidth={stroke}
                strokeDasharray={`${circumference} ${circumference}`}
                strokeDashoffset={strokeDashoffset}
                r={normalizedRadius}
                cx={radius}
                cy={radius}
                style={{
                    transition: 'stroke-dashoffset 1s linear',
                    transform: 'rotate(-90deg)',
                    transformOrigin: '50% 50%',
                }}
            />
        </svg>
    );
};

export default CountdownGauge;
